import { IEditorRequestProps } from "../../../utils/types";

const offset = 7

export const handlePopupPosition = (popupDOM: HTMLDivElement, commentDOM: Element | Range, popupParent: Element, editor: Element, editorMetadata: IEditorRequestProps, isNewDiscussion: boolean, isRangeComment: boolean) => {

  if (!commentDOM || !popupDOM) return

  const doc = editor.querySelector('#scrte-doc')
  const restrictedElement = ((editorMetadata.isFullScreen || editorMetadata.isPlugin) ? document.body : document.querySelector('.PageLayout__body__container')) ?? document.body
  const restrictedDim = restrictedElement.getBoundingClientRect()

  if (!doc || !popupParent) return
  const docDim = doc.getBoundingClientRect()
  const popupParentDim = popupParent.getBoundingClientRect()
  const commentDim = commentDOM.getBoundingClientRect()

  const right = popupParentDim.right - docDim.right
  const top = commentDim.top - popupParentDim.top
  popupDOM.style.top = `${top}px`
  popupDOM.style.right = `${right}px`
  popupDOM.style.bottom = "auto"

  const popupDim = popupDOM.getBoundingClientRect()
  let restrictedBottom = restrictedDim.bottom
  if (editorMetadata.isPlugin && editorMetadata.isFullScreen) { // for plugin fullscreen get bottom from innerHeight
    restrictedBottom = window.innerHeight
  }

  const isPopupExtending = popupDim.bottom > restrictedBottom

  if (isPopupExtending) {
    popupDOM.style.top = 'auto'
    let bottom;

    if (editorMetadata.isPlugin && editorMetadata.isFullScreen) { // for plugin fullscreen get bottom from innerHeight
      bottom = offset
    }
    else {
      bottom = popupParentDim.bottom - restrictedBottom + offset
    }
    popupDOM.style.bottom = `${bottom}px`

  }
}